import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import productService from "./ProductService";
import ProductTagParametersDialog from "./ProductTagParametersDialog";
import ProductGroup from "./ProductGroup";
import {
    FaHome,
    FaLink,
    FaUnlink
} from "react-icons/fa";
import InputField from "../../componentes/form-fields/InputField/InputField";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import DefaultChip from "../../componentes/chip/DefaultChip";

export default function ProductColoplast() {
    const { t } = useTranslation();
    const { control } = useForm();

    const userId = sessionStorage.getItem("userId");
    const initialProductState = {
        idProduct: 0,
        idClient: 1,
        productName: '',
        barCode: '',
        sku: '',
        productCode: '',
        anvisaRegNumber: '',
        advertence: '',
        productGroup: 0,
        qttyBox: '',
        status: 1,
        userId: userId
    };


    const [product, setProduct] = useState(initialProductState);

    const { idProduct, productName, barCode, sku, productCode, anvisaRegNumber, advertence, idClient, status, warningProduct } = product

    const [clearedProduct, setClearedProduct] = useState(false);
    const [programRoleRows, setProductRows] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const columnsProduct = (t) => [
        {
            field: "idCliente",
            textAlign: 'center',
            visible: false,
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="idCliente" name="" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.idClient}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "idProduct",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="id" name="code" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.idProduct}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "productName",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productName" name="productName" />;
            },
        },
        {
            field: "barCode",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="barCode" name="code" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="grey"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.barCode}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "sku",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="sku" name="qrCode" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="grey"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.sku}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "productCode",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productCode" name="code" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="grey"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.productCode}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "anvisaRegNumber",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="anvisaRegNumber" name="" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="grey"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.anvisaRegNumber}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "advertence",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="advertence" name="" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="grey"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.advertence}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "status",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="statusCode" name="status" />;
            },
            template: (props) => {
                return (
                    <>
                        {props.status ? (
                            <IconSwitch name="active" />
                        ) : (
                            <IconSwitch name="canceled" />
                        )}
                    </>
                );
            },
        },
    ];

    const handleChange = (event) => {
        const { name, value } = event.target;
        setProduct({ ...product, [name]: value });
    };

    const handleCloseAlertProduct = () => {
        setProduct({ ...product });
        setError(false);
        setSuccess(false);
    };

    const handleClearProduct = () => {
        setClearedProduct(!clearedProduct);
        setProduct(initialProductState);
        setProductRows([]);
        setError(false);
        setSuccess(false);
    };

    const handleSearchProduct = () => {
        let request = {
            ...product
        }

        productService
            .getProductColoplast(request)
            .then((response) => {
                setProductRows(response.data)
            })
            .catch((e) => {
            });
    };

    const canSaveProduct = () => {
        if (!productName || !barCode || !sku || !productCode || !anvisaRegNumber || !idClient) {
            setError(true);
            setMessage(t("fillRequiredFields"));
            return false;
        } else if (status === 0) {
            console.log("status cancelado", status);
            setError(true);
            setMessage(t("errorCannotRegisterCancelledProduct"));
            return false;
        }

        setError(false);
        return true;
    };

    const canUpdateProduct = () => {
        if (!productName || !barCode || !sku || !productCode || !anvisaRegNumber || !idClient) {
            setError(true);
            setMessage(t("fillRequiredFields"));
            return false;
        }

        setError(false);
        return true;
    };

    const handleSaveProduct = () => {
        let request = { ...product, userId: userId };

        if (idProduct !== 0) {
            if (!canUpdateProduct()) return;
        } else {
            if (!canSaveProduct()) return;
        }

        setMessage("");
        setSuccess(false);
        setProduct({ ...product, warningProduct: false });
        productService
            .createProductColoplast(request)
            .then((response) => {
                setProduct({ ...product, id: response.data.idProduct });
                setProductRows(response.data)
                setMessage(t("saveSuccess"));
                setSuccess(true);
                handleSearchProduct();
            })
            .catch((e) => {
                setMessage(t("saveError"));
                handleWarningProduct();
            });

    };

    const handleWarningProduct = () => {
        setProductRows([]);
        if (product.idRole !== 0) {
            setProduct({ ...product, warningProduct: true });
        }
    };

    const handleClickGrid = (rowData) => {
        setMessage("");
        setSuccess(false);

        setProduct({
            idProduct: rowData.idProduct,
            productName: rowData.productName,
            barCode: rowData.barCode,
            sku: rowData.sku,
            productCode: rowData.productCode,
            anvisaRegNumber: rowData.anvisaRegNumber,
            advertence: rowData.advertence,
            idClient: rowData.idClient,
            productGroup: rowData.productGroup,
            qttyBox: rowData.qttyBox,
            status: rowData.status
        });
    }

    // useEffect(() => {
    //     handleSearchProduct();
    // }, [product.idRole]);
    useEffect(() => {
        handleSearchProduct();
    }, [])

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="product"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                error={error}
                                success={success}
                                message={message}
                                warning={warningProduct}
                                handleCloseAlert={handleCloseAlertProduct}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <div style={{
                                        pointerEvents: "none",
                                        opacity: 0.8
                                    }}>
                                        <DefaultAutocomplete
                                            iconLabelSwitch={
                                                <IconLabelSwitch
                                                    name="unLock"
                                                    labelName="client"
                                                />
                                            }
                                            name="idClient"
                                            disabled={true}
                                            value={idClient}
                                            defaultSize
                                            useApi
                                            endpoint='GetClient'
                                            error={error && idClient === 0}

                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="productName" labelName="productName" />
                                        }
                                        name="productName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productName}
                                        length={50}
                                        error={error && productName === ""}
                                    />
                                </Grid>
                            </GridInputRow>
                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="barCode" labelName="barCode" />
                                        }
                                        name="barCode"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={barCode}
                                        length={30}
                                        error={error && barCode === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="qrCode" labelName="sku" />
                                        }
                                        name="sku"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={sku}
                                        length={30}
                                        error={error && sku === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="productCode" />
                                        }
                                        name="productCode"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productCode}
                                        length={30}
                                        error={error && productCode === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="" labelName="anvisaRegNumber" />
                                        }
                                        name="anvisaRegNumber"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={anvisaRegNumber}
                                        length={30}
                                        error={error && anvisaRegNumber === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="" labelName="advertence" />
                                        }
                                        name="advertence"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={advertence}
                                        length={30}
                                        error={error && advertence === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                    />
                                </Grid>
                            </GridInputRow>
                            <SearchClearSaveRow
                                onClickClear={handleClearProduct}
                                onClickSearch={handleSearchProduct}
                                onClickSave={handleSaveProduct}
                            // customButtons={
                            //     <>
                            //         <Grid item>
                            //             <ProductGroup />
                            //         </Grid>

                            //         {idProduto !== 0 &&
                            //             <Grid item>
                            //                 <ProductTagParametersDialog
                            //                     _idProduto={idProduto} />
                            //             </Grid>}
                            //     </>
                            // }
                            />

                        </GridItemContainer>
                    </>
                }
            />
            {programRoleRows.length > 0 ? (
                <DefaultScreenAccordion
                    fields={
                        <DefaultDatagrid
                            columns={columnsProduct(t, handleSearchProduct)}
                            dataSource={programRoleRows}
                            cellSelected={(args, grid) => handleClickGrid(args.data)}
                            allowPaging={true}
                        />
                    } />
            ) : null}
        </>
    );
};
